export const formatRows = (listaItems) => 
  listaItems.map((item) => ({
    id: item.id || "Id no disponible",
    cli_codigo: item.cli_codigo || "Código cliente no disponible",
    razon_social: item.razon_social || "Nombre del cliente no disponible",
    cli_name: item.cli_name || "",
    categ_id: item.la_categoria?.categ_descripcion || "Categoria del Cliente no disponible",
  }));
